<template>
  <div>
    <HeroSection />
    <DirectionsSection />
    <InstitutionsSection :institutions="universities" />
    <HowToSection />
    <ProgrammesSection />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useUniversityStore } from 'stores/university-store'
import { useProgrammeStore } from 'src/stores/programme-store'

import { useSeoMeta } from 'src/composables/useSeoMeta'

import DirectionsSection from 'components/home/DirectionsSection.vue'
import InstitutionsSection from 'components/home/InstitutionsSection.vue'
import HowToSection from 'components/home/HowToSection.vue'
import ProgrammesSection from 'components/home/ProgrammesSection.vue'
import HeroSection from 'components/home/HeroSection.vue'

const { t } = useI18n()

useSeoMeta({
  title: () => t('home.hero_section.subtitle'),
  description: () => t('home.hero_section.paragraph'),
  type: 'website',
  schema: () => ({
    type: 'WebSite',
    data: {
      url: import.meta.env.VITE_REDIRECT_URI,
    },
  }),
})

const universityStore = useUniversityStore()

const { universities } = storeToRefs(universityStore)

defineOptions({
  async preFetch({ store }) {
    const universityStore = useUniversityStore(store)
    const programmeStpre = useProgrammeStore(store)
    await Promise.all([
      universityStore.initAllUniversities({}, { type: '1' }),
      programmeStpre.initProgrammes(
        { limit: 4, sort: 'is_featured', order: 'desc' },
        { accept_applications: true }
      ),
    ])
  },
})
</script>

